import { letterSpacing } from "@mui/system";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import moment from "moment";
import {getPublicImagePath} from "../App"

export default function build_route_pdf(data, plant) {
    let tableOne = null;
    let tableTwo = 0;
    const equipStatusDesc = {
      'NORM': 'REPLENISHMENT',
      'PREM': 'REMOVAL',
      'DISP': 'DISPOSAL',
      'NOPH': 'NON-PHYSICAL',
      'INIT': 'INTIAL FILL'
    }
    let dateTime = `${moment().format('MM/DD/YYYY HH:MM A')}`
    const doc = new jsPDF("l","","letter")
    doc.page = 1
    const pageWidth = doc.internal.pageSize.getWidth()
    let tabl = 0
    var onlineimg = new Image()
    onlineimg.src='../online.png';

    var offimg = new Image()
    offimg.src='../offline.png'
    //
    let totalMaterialLength = 0;
    // let user = ''
    data?.forEach((element, index) => {
        ganaratePdf(element)
        doc.addPage();
    });
    function ganaratePdf(element) {
        header(element);
    }
  // function convertImageToBase64(url) {
  //   return new Promise((resolve, reject) => {
  //     const canvas = document.createElement("canvas");
  //     const ctx = canvas.getContext("2d");
  //     const img = new Image();
  //     img.crossOrigin = "Anonymous";
  //     img.onload = function () {
  //     canvas.width = this.width;
  //     canvas.height = this.height;
  //     ctx.drawImage(this, 0, 0);
  //     const dataURL = canvas.toDataURL("image/png");
  //       resolve(dataURL);
  //     };
  //     img.onerror = function () {
  //       reject("Image failed to load");
  //     };
  //     img.src = url;
  //   });
  // }

    function header(element) {

     if(element.board==="O"){
        doc.setFontSize(23);
        doc.setFont("Arial_Bold","bold");
        doc.text("Driver Itinerary", 5, 10);

        doc.setFontSize(10);
        doc.text(`${element.status}`, 132, 10);
        doc.rect(130, 5, 25, 7);

        doc.setFont("Arial_Bold", "bold");
        doc.text("Plant : ", 6, 20);
        doc.setFont("Arial_Bold", "bold");
        doc.text(`${element.dIRranch}`, 20, 20);

        doc.setFont("Arial_Bold", "bold");
        doc.text("Route : ", 100, 20);
        doc.setFont("Arial_Bold", "bold");
        doc.text(`${element.route}`, 115, 20);

        doc.setFont("Arial_Bold", "bold");
        doc.setFont("Arial_Bold", "bold");
        doc.text(`${element.fill_date}`, 140, 20);

        doc.setFont("Arial_Bold", "bold");
        doc.text("Driver : ", 192, 20);
        if(element.driver_settlement===true){
          doc.text("*Driver : ", 192, 20);
        }
        doc.setFont("Arial_Bold", "bold");
        doc.text(`${element.driver_itinerary}`, 205, 20);
      
        doc.setFontSize(8);
        doc.setFont("Arial_Bold", "bold");
        var raw = []
        element.customerList?.map((item, index) => {
          
          const Dnotes = []
          item?.driverNotes?.map(note => {
            Dnotes.push(`${note?.text}`)
          })  
          const Cnotes = []
          item?.cusNotes?.map(note => {
            Cnotes.push(`${note?.text}`)
          })

          const dexErrors = item?.dexErrorlist;
          let rowSpanCount = 1
          if(Dnotes?.length > 0){
            rowSpanCount++
          }
          if(Cnotes?.length > 0){
            rowSpanCount++
          }
          if(dexErrors?.length > 0){
            rowSpanCount++
          }
          const slNo=index+1;
          let fillcolor = [242, 242, 242];
          if(slNo%2===0){
            fillcolor = [255, 255, 255]; 
          }
           item.style = fillcolor;
           item.stop = { rowSpan: rowSpanCount, styles: {fillColor : fillcolor, halign: 'center', valign: 'middle'}};
           raw.push(item)
          
          
          if(Dnotes?.length > 0){
            raw.push({activity:{content: "Driver Notes: " + Dnotes.toString().replace(/(\r\n|\n|\r)/gm, " ").trim(), colSpan: 13, styles: {fillColor : fillcolor}}})
          }
          if(Cnotes?.length > 0){
            raw.push({activity:{content: "Customer Notes: " + Cnotes.toString().replace(/(\r\n|\n|\r)/gm, " ").trim(), colSpan: 13, styles: {fillColor : fillcolor}}})
          }
          if(dexErrors?.length > 0){
            raw.push({activity:{content: "Dex Errors: " + dexErrors.toString(), colSpan: 13, styles: {fillColor : fillcolor}}})
          }
          
        })
      // console.log("####"); console.log(raw);
        // var body = []
        // for (var i = 0; i < raw.length; i++) {
        //   var row = []
        //   for (var key in raw[i]) {
        //     row.push(raw[i][key])
        //   }
        //   if (i % 2 === 0) {
        //   row.unshift({
        //     rowSpan: 2,
        //     content: i / 2 + 1,
        //     styles: { valign: 'middle', halign: 'center' },
        //   })
        //   }
        //   body.push(row)
        // }

       autoTable(doc, {
            startY: 24,
            margin: { right: 5, left: 5 },
            columnStyles: {
                0: { cellWidth: 'auto' },
                1: { cellWidth: 'auto' }

            },
            didParseCell: (data) => {
               if(data?.row?.raw?.style){
                const fillcolor=data.row.raw.style;
                data.cell.styles.fillColor = fillcolor;
               }
           
               if(data.column.index==11 && data.section === 'body' && data?.row?.raw.last_sett!==data?.row?.raw.last_fill){
                    let fillcolor = [204, 204, 204];
                    data.cell.styles.fontStyle = 'bold';
                    data.cell.styles.fontSize = '9';
                    data.cell.styles.fillColor = fillcolor;
               }

               if(data.column.index==0 && data.cell.text[0]!=="NORM" && data.section === 'body'){
                if(!data.cell.raw.content){
                  let fillcolor = [204, 204, 204];
                  data.cell.styles.fontStyle = 'bold';
                  data.cell.styles.fontSize = '9';
                  data.cell.styles.fillColor = fillcolor;
                }
               }
                
                tableOne = data.table
                if(data.section === 'body' &&
                 data.column.index === 1 &&
                  data.column.dataKey === 'customerName' &&
                   typeof(data.cell.raw) !== 'string' ) {

                  //let text = []
                  // const content = data?.cell?.raw?.content
                  // content?.map(item => {
                  //   let result = item
                  //   text.push(result)
                  // })
                  //data.cell.text = text
                 // data.cell.raw.content = text
                }
            },
            bodyStyles: {
              textColor: '#000'
            },
            styles: {
                overflow: 'linebreak',
                fontSize: 8,
            },
            headStyles :{fillColor : [192, 192, 192],textColor: '#000'},
            body: raw,
            columns: [
                { header: 'Activity', dataKey: 'activity' },
                { header: 'Cust. #', dataKey: 'customerNum' },
                { header: 'Name', dataKey: 'diCustomerName' },
                { header: 'Asset', dataKey: 'assestNum' },
                { header: 'Tel.ID/Serial#', dataKey: 'tel_serial' },
                { header: 'Address', dataKey: 'dILocation' },
                { header: 'H.Route', dataKey: 'home_rt' },
                { header: 'FP', dataKey: 'fillRate' },
                { header: 'EA', dataKey: 'units' },
                { header: 'SO', dataKey: 'sos' },
                { header: '*Last Sett', dataKey: 'last_sett' },
               { header: 'Last FKey', dataKey: 'last_fill' },
                { header: 'LstInvUpd', dataKey: 'lastInventoryUpdate' },
               
            ],
            theme: 'plain',
        })
        footer(element)
      }

        Body(element.customerList,element)
    };
   

    function Body(obj,element) {

      let board = element.board;
      if(board=="P"){
        var pageCount = doc.internal.getNumberOfPages();
        doc.deletePage(pageCount);
      }
        obj.forEach((element, i) => {
          totalMaterialLength = element?.matList?.length;
           if(element.matList.length>15){
             overflow(element,element.matList,obj,i,board);
           }else{
            bodyWrite(element,element.matList,obj,i,board);
      }
      let posVal = doc.lastAutoTable.finalY;
    if(posVal>145){
      bodyWrite(element,[],obj,i,board);
    }
        bodyFooter(element)
        footer(element)
    });
    
    }
    
    function overflow(obj,matList,object,j,board){
      let n = 0;
      const len = matList.length;
      while (n < len) {
        let end = n + 30;
        if (end > len) {
          end = len;
        }
        const sliced = Object.assign(matList.slice(n, end));
        bodyWrite(obj,sliced,object,j,board);
        n = end;
      }
    }
    function bodyWrite(obj,matList,object,j,board){
      doc.addPage("letter");
      doc.setFontSize(23);
      doc.setFont("Arial_Bold","bold");
      doc.text("Route Card ", 5, 10);
      let position = 0//tableOne.finalY + 0; //tableOne.finalY+5
      doc.line(0, position, 560, position);
      
      doc.setFontSize(8);
      doc.setFont("Arial_Bold", "bold");
      doc.text(`Route ${obj.route} : `, 57, position + 8);
      if(obj.route.length>4){
        doc.text(`${obj.fill_date}`, 79, position + 8);
      }else{
        doc.text(`${obj.fill_date}`, 74, position + 8);
      }

      doc.text("Driver: ", 112, position + 8);
      doc.text(` ${obj.driver} `, 122, position + 8);
      if(obj.driver_settlement===true){
        doc.text(`* ${obj.driver} *`, 122, position + 8);
      }
      doc.setFontSize(10);
      doc.text(`[${obj.h1status}]`, 191, 8);
      //doc.rect(130, 4, 24, 6);

      doc.setFontSize(8);
      doc.setFont("Arial_Bold", "bold");
      doc.text(`Route Card # : `, 240, position + 8);
      doc.setFont("Arial_Bold", "bold");
      doc.text(`${j + 1} of ${object?.length}`, 260, position + 8);
      doc.line(1, position + 12, 560, position + 12);

      /****row  */
     
      doc.setFontSize(8);
      doc.setFont("Arial_Bold", "bold");
      doc.text("Name:", 5, position + 16);
      doc.setFont("Arial", "normal");
      var splitTitle = doc.splitTextToSize(obj.customerName.substring(0, 48), 94);
      doc.text(splitTitle,16, position + 16);
      
      doc.setFont("Arial_Bold", "bold");
    doc.text("Cust #: ", 5, position + 21);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.customerNum}`, 16, position + 21);

    doc.setFont("Arial_Bold", "bold");
    doc.text("Address: ", 5, position + 26);
    doc.setFont("Arial", "normal");
    const splitCuslocation = doc.splitTextToSize(`${obj.location}`, 80);
    if(splitCuslocation?.length > 1){
      for (let i = 0; i < splitCuslocation?.length; i++) {
        const text = splitCuslocation[i];
        if(i === 0 ){
          doc.text(19,  position+26, text);
        }else {
          const prevText = splitCuslocation[i - 1]
          const prevTextDim = doc.getTextDimensions(prevText)
          const prevTextHeight = prevTextDim?.h
          if(position+27 + ((i-1) * 1.75) + prevTextHeight < position + 33){
            doc.text(19,  position+26 + ((i-1) * 1.75) + prevTextHeight, text);
          }else {
            break
          }
        }
      }
    }else{
      doc.text(`${splitCuslocation}`, 19, position + 26);
    }

    doc.setFont("Arial_Bold", "bold");
    doc.text("City/Rg/Zip: ", 5, position + 31);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.location_zip}`, 22, position + 31);

    doc.setFont("Arial_Bold", "bold");
    doc.text("Contact: ", 5, position + 36);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.contactInfo.first_name} ${(obj.contactInfo.contact_number)}`, 18, position + 36);
     //doc.text(`DENISE (Ph. 770-819-2414)`, 17, position + 36);

    doc.setFont("Arial_Bold", "bold");
    doc.text("BankNm: ", 5, position + 41);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.bank}`, 18, position + 41)

    doc.setFont("Arial_Bold", "bold");
    doc.text("Delivery Plant/Home Route: ", 5, position + 46);
    doc.setFont("Arial", "normal");
    doc.text(`${plant}/${obj.home_rt}`, 45, position + 46);
    /****row  */

    doc.setFont("Arial_Bold", "bold");
    doc.text("Activity: ", 105, position + 16);
    if(obj.activity!=="NORM"){
      doc.setFontSize(10);
      doc.setFont("Arial_Bold", "bold");
      doc.setDrawColor(0);
      doc.setFillColor(204, 209, 209);
      doc.rect(117, position + 13.2, 46, 4, 'F');
      doc.text(`**${obj.activity} - ${equipStatusDesc[obj.activity]}**`, 117, position + 16);
     
    }else{
      doc.setFont("Arial", "normal");
      doc.text(`${obj.activity} - ${equipStatusDesc[obj.activity]}`, 117, position + 16);

    }
    doc.setFontSize(8);
    doc.setFont("Arial_Bold", "bold");
    doc.text("Equip Loc: ", 105, position + 21);
    doc.setFont("Arial", "normal");
    const splitEquipmentlocation = doc.splitTextToSize(`${obj?.equipLocation}`, 80);
    if(splitEquipmentlocation?.length > 1){
      for (let i = 0; i < splitEquipmentlocation?.length; i++) {
        const text = splitEquipmentlocation[i];
        if(i === 0 ){
          doc.text(120,  position+21, text);
        }else {
          const prevText = splitEquipmentlocation[i - 1]
          const prevTextDim = doc.getTextDimensions(prevText)
          const prevTextHeight = prevTextDim?.h
          if(position+21 + ((i-1) * 1.75) + prevTextHeight < position + 26){
            doc.text(120,  position+21 + ((i-1) * 1.75) + prevTextHeight, text);
          }else {
            break
          }
        }
      }
    }else{
      doc.text(`${splitEquipmentlocation}`, 120, position + 21);
    }

    doc.setFont("Arial_Bold", "bold");
    doc.text("Model/Asset: ", 105, position + 26);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.model} / ${obj.assestNum}`, 123, position + 26);

    doc.setFont("Arial_Bold", "bold");
    doc.text("Mser#/Equ#: ", 105, position + 31);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.manufacturer}/${parseInt(obj.equipmentNum)}`, 123, position + 31);

    doc.setFont("Arial_Bold", "bold");
    doc.text("TelSer #: ", 105, position + 36);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.tel_serial}`, 118, position + 36);

    doc.setFont("Arial_Bold", "bold");
    doc.text("Coin Fund: ", 105, position + 41);
    doc.setFont("Arial", "normal");
    doc.text(`$${obj.coin}`, 121, position + 41);

    /****row  */
    doc.setFont("Arial_Bold", "bold");
    doc.text("Last Sett: ", 190, position + 16);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.last_sett}`, 204, position + 16);
    if(obj.driver_settlement===true){
      doc.text(`* ${obj.last_sett}`, 204, position + 16);
    }
 

    doc.setFont("Arial_Bold", "bold");
    doc.text("Last Fill Key: ", 190, position + 21);
    doc.setFont("Arial", "normal");
    if(obj.last_fill!=obj.last_sett && obj.last_fill!==""){
      doc.setFontSize(8);
      doc.setFont("Arial_Bold", "bold");
      doc.setDrawColor(0);
      doc.setFillColor(204, 209, 209);
      doc.rect(209, position + 18, 39, 4, 'F');
      doc.text(`**${obj.last_fill}**`, 209, position + 21);
    }else{
      doc.setFontSize(8);
      doc.text(`${obj.last_fill}`, 209, position + 21);
    }

    if(obj.isTelExceeded){
      doc.setFontSize(8);
      doc.setFont("Arial_Bold", "bold");
      doc.setDrawColor(0);
      doc.setFillColor(204, 209, 209);
      doc.rect(190, position + 23, 41, 4, 'F');
      doc.text(`${obj.lastInventoryUpdate} (No Call)`, 204, position + 26);
    }else{
      doc.setFontSize(8);
      doc.setFont("Arial", "normal");
      doc.text(`${obj.lastInventoryUpdate}`, 204, position + 26);
    }
    doc.setFontSize(8); 
    doc.setFont("Arial_Bold", "bold");   
    doc.text("Last Invt:", 190, position + 26);
    
    doc.setFont("Arial_Bold", "bold");
    doc.text("AccessDay:", 190, position + 31);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.acces_days}`, 207, position + 31);

    doc.setFont("Arial_Bold", "bold");
    doc.text("Sales Day: ", 190, position + 36);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.sales_days}`, 205, position + 36);

    doc.setFont("Arial_Bold", "bold");
    doc.text("SvcGrp: ", 190, position + 41);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.sgn_gp}`, 201, position + 41);

    doc.setFont("Arial_Bold", "bold");
    doc.text("Sch/Ffreq: ", 190, position + 46);
    doc.setFont("Arial", "normal");
    doc.text(`${obj.schedule_type} ${obj.fi_frag?' / '+obj.fi_frag:''} ${obj.sales_days_count?' / '+obj.sales_days_count:''}`, 205, position + 46);

    /****row  */
    const onlineText = "!!PRESS FILL KEY [ ]\n When Servicing Machine";
    // const imgs = (obj.is_online==true)? getPublicImagePath("./online.png"): getPublicImagePath("./offline.png");
    const imgText = (obj.is_online==true)? `${onlineText}`: `Offline Outlet`;
    const imgSize = (obj.is_online==true)? `248`: `243`;

    if(obj.is_online ){
      doc.addImage(onlineimg, "PNG", imgSize,position+16,10, 10,'FAST');
     }
     else{
      doc.addImage(offimg, "PNG", imgSize,position+16,10, 10,)
     }
      var pageCount = doc.internal.getNumberOfPages();
    doc.setFont("Arial_Bold", "bold");
    doc.text(imgText, 240, position + 31);
    doc.text(`!!Verified Closing Inventory\n is Accurate[ ]`, 240, position + 40);

    doc.setFont("Arial", "normal"); 

      doc.setFontSize(8);
      autoTable(doc, {
          startY: position + 48,
          margin: { right: 5, left: 5 },
          columnStyles: {
            0: { cellWidth: 12 },
            1: { cellWidth: 69 },
            2: { cellWidth: 44 },
            3: { cellWidth: 44 },
            4: { cellWidth: 14 },
            5: { cellWidth: 14},
            6: { cellWidth: 10},
            7: { cellWidth: 10},
            8: { cellWidth: 14},
            9: { cellWidth: 8},
            10: { cellWidth: 8},
            11: { cellWidth: 18},
            12: { cellWidth: 7}

        },
          didParseCell: (data) => {
              tableTwo = data.table.body;
              if (data.column.index === 0 || data.column.index === 1 ) {
                data.cell.styles.fontStyle = 'bold';
                data.cell.styles.fontSize = '8';
              }
              if ((data.column.index === 2 || data.column.index === 3) && ((data?.row?.raw.colMis==="true") || (data?.row?.raw.priceH==="true")) ) {
                let fillcolor = [204, 204, 204];
                data.cell.styles.fontStyle = 'bold';
                data.cell.styles.fontSize = '8';
                data.cell.styles.fillColor = fillcolor;
              }
              if((data.column.index==4 || data.column.index==5 )&& data.section === 'body'){
                if( (data?.row?.raw.vp!=="" && data?.row?.raw.dex_vp!=="") && (data?.row?.raw.vp!==data?.row?.raw.dex_vp)){
                  let fillcolor = [204, 204, 204];
                  data.cell.styles.fontStyle = 'bold';
                  data.cell.styles.fontSize = '8';
                  data.cell.styles.fillColor = fillcolor;
                }
            }
          
              
          },
          didDrawCell: (data) => {
            var tableTwo = data.table.body;
            if (data.section === 'body' && data.column.index === 11 && data.row.index !== tableTwo.length - 1) {
            doc.setDrawColor(96,95,95);
            doc.setLineWidth(0.3);
            doc.line(data.cell.x, data.cell.y+4, data.cell.x + data.cell.width,data.cell.y+4);
            }

            if ((data.row.index === totalMaterialLength - 1) && (data?.row?.raw.dex_vp)) {
              doc.setDrawColor(0,0,0);
              doc.setLineWidth(0.6);
              doc.line(data.cell.x, data.cell.y+0.1, data.cell.x + data.cell.width,data.cell.y+0.1);
             doc.line(data.cell.x, data.cell.y+5, data.cell.x + data.cell.width,data.cell.y+5); 
          }
        },
          styles: {
              overflow: 'linebreak',
              fontSize: 8,
              cellPadding: 0.8
          },
          bodyStyles: {
            textColor: '#000'
          },
          headStyles :{fillColor : [192, 192, 192],textColor: '#000'},
          body: matList,
          columns: [
              { header: 'SKU', dataKey: 'material_num' },
              { header: 'PRODUCT', dataKey: 'material_name' },
              { header: 'COLS', dataKey: 'col' },
              { header: 'BTNS', dataKey: 'btns' },
              { header: 'SAP-VP', dataKey: 'vp' },
              { header: 'DEX-VP', dataKey: 'dex_vp' },
              { header: 'FL', dataKey: 'fl' },
              { header: 'SPD', dataKey: 'spd' },
              { header: 'FR%', dataKey: 'fr' },
              { header: 'CS', dataKey: 'cs' },
              { header: 'EA', dataKey: 'ea' },
              { header: 'INVENTORY', dataKey: 'inventory' }, 
              { header: '', dataKey: 'so' }, 
          ],
      });
      totalMaterialLength = totalMaterialLength - matList.length;
      //adding code to add footer in each page
      doc.setDrawColor(0)
      doc.setLineWidth(0.2)
      doc.line(4, 209, pageWidth, 209)
      doc.setFontSize(8);
      // let today=new Date()
      doc.text(`${dateTime}`, 4, 213);
      doc.text(`User: ${obj?.userEmail}`, 105, 213);
    }
    function bodyFooter(obj) {
      //let pos = doc.internal.pageSize.height - 95
      let pos = doc.lastAutoTable.finalY; // The y position on the page
      const dexErrors= obj.dexErrorlist;
      doc.setFontSize(8);
      doc.setFont("Arial_Bold", "bold");
     doc.text("Errors:", 5, pos+5);
     doc.line(5, pos+6, 4 + doc.getTextWidth("Errors:"), pos + 6)
    let text = dexErrors.toString();

 
      //let text = " ExcessEscrow - EE MachineSalesSettlement - MSS. Relocate - RELO, SoldOut-S0, SoldUnder-SU, SoldUnderMachine-SUM, ExcessEscrow - EE MachineSalesSettlement - MSS. Relocate - RELO trytrytrytrytry"
      var splitTitle = doc.splitTextToSize(text, 260);  
      doc.text(splitTitle, 16, pos+5);
      let customerNotes = "Customer Notes:"
      let driverNotes = "Driver Instructions:"
      doc.setDrawColor(0)
      doc.setLineWidth(0.2)
      doc.setFont("Arial_Bold", "bold");
      doc.text(customerNotes.replace(/(\r\n|\n|\r)/gm, " ").trim(), 5, pos + 19)
      doc.setFont("Arial", "normal");
      doc.line(5, pos+20, 4 + doc.getTextWidth(customerNotes), pos + 20)
      if(obj?.cusNotes?.length > 0){
        const customerNotesT =obj?.cusNotes.map(u => u.text).join(' , ').replace(/(\r\n|\n|\r)/gm, " ").trim()
       // const customerNotesT = 'customer notes 2, Customer Testing notes, customer Notes 3,  customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3 , customer Notes 3, customer Notes 3, customer Notes 3, customer Notes 3, customer Notes 3, customer Notes 3, customer Notes 3, customer Notes 3';
        if(customerNotesT.length>513){
          const notesText = customerNotesT.substring(0, 500);
          const text = notesText+'...see driver itinerary';
          var splitTitle = doc.splitTextToSize(text, 172);
          doc.text(29,  pos+19,splitTitle );
        }else{
          var splitTitle = doc.splitTextToSize(customerNotesT, 172); 
          doc.text(29,  pos+19, splitTitle);
        }
       
       /*  for (let i = 0; i < obj?.cusNotes?.length; i++) {
          const element = obj?.cusNotes[i];
          const text = doc.splitTextToSize(element?.text, 120);
          if(i === 0 ){
            doc.text(29,  pos+19, text);
          }else {
            const prevElement = obj?.cusNotes[i - 1]
            const prevText = doc.splitTextToSize(prevElement?.text, 120)
            const prevTextDim = doc.getTextWidth(prevText)
           // if(pos+21 + (i * 3) + prevTextHeight < pos + 31){
              doc.text(29+prevTextDim+(i * 1),  pos+19, ','+text);
            //}else {
             // break
            //}
          }
        } */
      }
      doc.setFont("Arial_Bold", "bold");
      doc.text(driverNotes, 5, pos + 35);
      doc.setFont("Arial", "normal");
      doc.line(5, pos+36, 4 + doc.getTextWidth(driverNotes), pos + 36)
      if(obj?.driverNotes?.length > 0){
        const driverNotesT =obj?.driverNotes.map(u => u.text).join(' , ').replace(/(\r\n|\n|\r)/gm, " ").trim()
        if(driverNotesT.length>513){
          const notesText = driverNotesT.substring(0, 490);
          const text = notesText+'...see driver itinerary';
          var splitTitle = doc.splitTextToSize(text, 168);
          doc.text(32, pos + 35,splitTitle );
        }else{
          var splitTitle = doc.splitTextToSize(driverNotesT, 168); 
          doc.text(32,  pos + 35, splitTitle);
        }
        // var splitTitle = doc.splitTextToSize(driverNotesT, 172); 
        // doc.text(32,  pos + 35, splitTitle);

       /* for (let j = 0; j < obj?.driverNotes.length; j++) {
          const element = obj?.driverNotes[j];
          const text = doc.splitTextToSize(element?.text, 120);
          if(j === 0 ){
            doc.text(32,  pos + 35, text);
          }else {
            const prevElement = obj?.driverNotes[j - 1]
            const prevText = doc.splitTextToSize(prevElement?.text, 120)
            const prevTextDim = doc.getTextDimensions(prevText)
            const prevTextHeight = prevTextDim?.h
            if(pos+40 + (j * 3) + prevTextHeight < pos + 50){
              doc.text(32,  pos + 35, text);
            }else {
              break
            }
          }
        }*/
      }
      let driverCommenter = "Driver Comments (for additional room.use other side of this Report)"
      doc.setFont("Arial_Bold", "bold");
      doc.text(driverCommenter, 5, pos + 54);
      doc.line(5, pos+55, 4 + doc.getTextWidth(driverCommenter), pos + 55)

      let VisitSection = "Visit Data (to be captured by Driver):";
      doc.setFontSize(8);
      doc.setFont("Arial_Bold", "bold");
      doc.text(VisitSection, 200, pos+20);
      doc.line(200, pos+21, 250, pos + 21)
      doc.setFontSize(8);

      doc.setFont("Arial_Bold", "bold");
      doc.text("CLEAR ERROR ", 200, pos + 26); 
      doc.text(" [", 222, pos + 26); 
      doc.setTextColor(169,169,169);
      doc.text(" Y / N ", 224, pos + 26); 
      doc.setTextColor(0,0,0);
      doc.text(" ] ", 231, pos + 26); 
     // doc.line(275, pos+26, 245, pos+26);
      doc.setFont("Arial_Bold", "bold");
      doc.text("STS SETUP OK?", 237, pos + 26);
      doc.text(" [", 262, pos + 26);
      doc.setTextColor(169,169,169);
      doc.text(" Y / N  ", 264, pos + 26);
      doc.setTextColor(0,0,0);
      doc.text(" ] ", 271, pos + 26); 
      //doc.line(275, pos+31, 245, pos+31);

      doc.setFont("Arial_Bold", "bold");
      doc.text("BAG #", 200, pos + 32);
      doc.setFont("Arial", "normal");
      doc.line(275, pos+31, 240, pos+31);

      doc.setFont("Arial_Bold", "bold");
      doc.text("SALES METER", 200, pos + 38);
      doc.setFont("Arial", "normal");
      doc.line(275, pos+37, 240, pos+37);

      doc.setFont("Arial_Bold", "bold");
      doc.text("VEND METER ", 200, pos + 44);
      doc.setFont("Arial", "normal");
      doc.line(275, pos+43, 240, pos+43);

      doc.setFont("Arial_Bold", "bold");
      doc.text("DEBIT/CREDIT CARD VALUE", 200, pos + 50);
      doc.setFont("Arial", "normal");
      doc.line(275, pos+50, 240, pos+50);

      doc.setFont("Arial_Bold", "bold");
      doc.text("TOTAL TEST VEND VALUE", 200, pos + 56);
      doc.setFont("Arial", "normal");
      doc.line(275, pos+57, 240, pos+57);

      //doc.rect(202, pos+19, 83, 54);

      

  }



    function footer(element) {
      
        doc.setDrawColor(0)
        doc.setLineWidth(0.2)
        doc.line(4, 209, pageWidth, 209)
        doc.setFontSize(8);
        // let today=new Date()
        doc.text(`${dateTime}`, 4, 213);
        doc.text(`User: ${element?.userEmail}`, 105, 213);
        doc.page ++;
    };
    var pageCount = doc.internal.getNumberOfPages();

    const currentURL = window.location.href.toLowerCase();
    const IS_TEST_ENV =
      process.env.NODE_ENV === "development" ||
      0 <= currentURL.indexOf("localhost") ||
      0 <= currentURL.indexOf("vending-dev") ||
      0 <= currentURL.indexOf("vending-mnt") ||
      0 <= currentURL.indexOf("vending-qa") ||
      0 <= currentURL.indexOf("vending-prf") ||
      0 <= currentURL.indexOf("ase-m-vdp-001") ||
      0 <= currentURL.indexOf("ase-d-vdp-001") ||
      0 <= currentURL.indexOf("ase-q-vdp-001") ||
      0 <= currentURL.indexOf("ase-l-vdp-001");

    for(var i = 1; i <= pageCount; i++) {
      // Go to page i
      doc.setPage(i);
      if (IS_TEST_ENV) {
      const pdfWatermarkMsg = process.env["PDF_WATERMARK_MESSAGE"] || "Test Data";
      // Get page dimensions
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Define maximum width for the text block (e.g., 70% of page width)
      const maxTextWidth = pageWidth * 0.7;

      // Split long text into an array of lines based on max width
      const textLines = doc.splitTextToSize(pdfWatermarkMsg, maxTextWidth);
      
      // Calculate center coordinates
      const centerX = pageWidth / 2;
      const lineHeight = doc.getLineHeight() * 0.352778; // convert pt to mm if units are mm, or keep internal units
      const totalBlockHeight = textLines.length * (doc.getFontSize() * 0.5); 
      const startY = (pageHeight / 2) - (totalBlockHeight / 2);
      //Save current graphics state
      doc.saveGraphicsState();

      // Set opacity/transparency (0.0 = completely invisible, 1.0 = solid)
      doc.setGState(new doc.GState({ opacity: 0.30 }));

      // Style the watermark text
      doc.setFont("helvetica", "bold");
      doc.setFontSize(60);
      doc.setTextColor("red"); // Gray color

      // Draw rotated text (X, Y, options object with rotation angle)
      // Rotation is in degrees, counter-clockwise
      doc.text(pdfWatermarkMsg, centerX, startY, {
        align: 'center'
      });

      // Restore graphics state so normal content isn't transparent
      doc.restoreGraphicsState();
    }

      doc.text(250,213, `Page ${String(i)} of  ${String(pageCount - 1)}`); 
    }

    doc.deletePage(pageCount)
    setTimeout(() =>  doc.save(`${data[0]?.branch}_route_card_${data[0]?.planningDate}.pdf`), 500);
    //doc.save(`${data[0]?.branch}_route_card_${data[0]?.planningDate}.pdf`);
}